import script from "./PromptConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./PromptConfig.vue?vue&type=script&setup=true&lang=js"

import "./PromptConfig.vue?vue&type=style&index=0&id=6a83cf6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a83cf6e"]])

export default __exports__